var styles = {
  imageThumbnail: {
    width: "150px",
    height: "auto",
  },
};

export default styles;
